<template>
  <div>
    <app-header :sysco="sysco"></app-header>
    <div class="container-fluid">
      <h2 class="display-4 text-primary"><strong>{{proj.customerName}} - {{proj.projectName}}</strong></h2>
      
      <h4 class="text-primary">{{caption("addwin_Window")}}: {{win.name}}</h4>
      <div class="row">
        <div class="col-lg-3 col-12">
          <window-graph :type="win.windowType" :dir="win.openDir" :hinge="win.hingeType" :handle="handleAN(win.handleAN)" :Fb1="win.fb1" :Fb2="win.fb2" :Fh="win.fh" :A="win.a" :W1="win.weight1" :W2="win.weight2" :dim="dimension" :scale="scale" :profile="win.profile" :config="0"></window-graph>
        </div>
        <div class="col-lg-9 col-12">
            <div><span class="badge mb-2 ml-1" :class="win.bulk == 0 ? 'badge-primary' : 'badge-success'">{{win.bulk == 0 ? caption("Set") : caption("Bulk")}}</span></div>
            <h4> Chrono {{chrono(win.chrono)}}</h4>
            <h5 class="text-primary">{{caption(hinge(win.hingeType))}}</h5>
            <h5 v-if="(win.windowType != 50 && win.windowType != 55)" class="text-secondary">{{win.handleAN != 'NONE' ? caption(handle(win.handleType)) : ''}} {{win.handleAN != 'NONE' ? handleAN(win.handleAN) : caption("addwin_NoHandle")}}</h5>
            <p><strong>{{groove(win.groove)}}</strong></p>
        </div>
      </div>
      <button type="button" style="font-size: 20px" class="btn btn-outline-primary btn-sm mt-3" @click="showWindowlist()"><i class="fas fa-chevron-left"></i> {{caption("winlist_Back")}}</button>
      <div class="mt-3">
          <h3>{{caption("pdf_BOM")}}</h3>
          <div class="row">
            <h5><button style="font-size: 20px" type="button" class="btn btn-sm btn-secondary ml-3 mr-2" @click="getCsv()"><strong><i class="fas fa-file-download"></i> .CSV</strong></button></h5>
            <h5><button style="font-size: 20px" type="button" class="btn btn-sm btn-secondary" @click="getXl()"><strong><i class="fas fa-file-download"></i> .XLSX</strong></button></h5>
          </div>
      </div>
      
      <hr>
      <div v-for="b in bom" v-bind:key="b.gan">
        <div class="row">
          <div class="col-md-1">
            <h5><div class="badge" :class="b.packaging == 'Set' ? 'badge-primary' : 'badge-success'">{{b.packaging}}</div></h5>
          </div>
          <div class="col-md-4">
            <div class=""><h5>{{b.quantity}} x <strong>{{b.gan}}</strong><span class="badge badge-primary ml-3" v-if="b.color != ''">{{b.color}}</span></h5></div>
            
          </div>
          <div class="col-md-7">
            <h5>{{b.description}}</h5>
          </div>
        </div>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import WindowGraph from "./WindowGraph";
import store from '../../ClientApp/store';
import { mapGetters } from "vuex";

export default {
  data: function(){
    return {
      dimension: true,
      scale: 10,
    }
  },
  components: {
    AppHeader,
    WindowGraph
  },
  computed: {
    proj() {
      return this.$store.state.project;
    },
    win() {
        return this.$store.state.window;
    },
    bom() {
      return this.$store.state.bom;
    },
    sysco(){
      return this.$store.getters.getAuth.systemCompany;
    },
    language(){
      return this.$store.state.auth.language;
    },
    ...mapGetters(['getChrono', 'getHinge', 'getHandle', 'getGroove'])
  },
  mounted() {
    this.$store.dispatch("windowbom", this.win.id);
  },
  methods: {
    showProjectlist(){
      this.$router.push("/projects");
    },
    showWindowlist(){
        this.$router.push("/projectwindows/" + this.proj.id);
    },
     chrono(c){
      let chr = this.getChrono.find(o => o.chronoId == c);
      return chr.chronoDesc;
    },
    handle(h){
      let han = this.getHandle.find(o => o.handleId == h);
      return han.handleDesc;
    },
    hinge(h){
      let hin = this.getHinge.find(o => o.hingeId == h);
      return hin.hingeDesc;
    },
    groove(g){
      let gro = this.getGroove.find(e => e.grooveId == g);
      return gro.grooveDesc;
    },
    handleAN(anr){
      var han = this.$store.getters.getHandleByAN(anr);
      return han.bmp;
    },
    getCsv() {
      this.$store.dispatch("windowcsv", this.win.id);
    },
     getXl() {
      this.$store.dispatch("windowxl", this.win.id);
    },
    caption(term){
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    }
  }
}
</script>

<style scoped>
    @media (min-width: 600px) {
        .container-fluid {
        width: 75%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/windows/WindowBom.vue